function Animations({ size }: { size: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={size} viewBox="0 0 24 24">
      <path d="M11 2l1.6 4.4L17 8l-4.4 1.6L11 14l-1.6-4.4L5 8l4.4-1.6L11 2z" fill="currentColor" />
      <path d="M18.5 13l.9 2.6 2.6.9-2.6.9-.9 2.6-.9-2.6-2.6-.9 2.6-.9.9-2.6z" fill="currentColor" />
      <path d="M5 15l.7 2 2 .7-2 .7L5 20.4l-.7-2-2-.7 2-.7L5 15z" fill="currentColor" />
    </svg>
  )
}

export default Animations
